import { render, staticRenderFns } from "./FlashSaleContent.vue?vue&type=template&id=0b908934&scoped=true&"
import script from "./FlashSaleContent.vue?vue&type=script&lang=js&"
export * from "./FlashSaleContent.vue?vue&type=script&lang=js&"
import style0 from "./FlashSaleContent.vue?vue&type=style&index=0&id=0b908934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b908934",
  null
  
)

export default component.exports